import React, { FunctionComponent } from 'react';

import { ImageMedia } from '../../../../types/__generated__';
import { onlyImages } from '../../../utils/typeGuards';
import { ImageGridWithLightbox } from '../../ImageGrid';
import { FitnessMessage } from '../Fitness/FitnessMessage';
import { TimelineEntryProps } from './TimelineEntry';

import timelineEntryStyles from '../TimelineEntry/TimelineEntry.scss';
import timelineStyles from '../Timeline.scss';
import { LazyLoader } from '../../LazyLoader/LazyLoader';
import { useTranslation } from 'react-i18next';

// Lazy loading the StravaMap as react-leaflet only works on client side
// and it loads the mapping library and css for leaflet so is only needed
// when rendering a map
const FitnessMapLazy = React.lazy(() => import('../Fitness/FitnessMap'));

export type BodyProps = Pick<TimelineEntryProps, 'timelineEntry'>;

export const Body: FunctionComponent<BodyProps> = ({
  timelineEntry: { message, media, fitnessActivity },
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const images = media?.filter(onlyImages);

  const fitnessMessage = fitnessActivity ? (
    <FitnessMessage
      message={message}
      caption={t('timeline.fitnessMessage.caption')}
      fitness={fitnessActivity}
    />
  ) : null;

  const mapPolyline = fitnessActivity?.mapPolyline;
  const activityMap = mapPolyline ? (
    <LazyLoader>
      <div
        className={timelineEntryStyles.mapContainer}
        data-qa={'fitness-map-wrapper'}
      >
        <FitnessMapLazy polyline={mapPolyline} />
      </div>
    </LazyLoader>
  ) : null;

  return (
    <div className={timelineStyles.body}>
      {fitnessMessage ? (
        fitnessMessage
      ) : (
        <div className={timelineEntryStyles.bodyMessage}>{message}</div>
      )}
      {activityMap}
      {images && images.length > 0 && (
        <ImageGridWithLightbox
          gridType="template"
          className={timelineEntryStyles.bodyGallery}
          images={images.map((m: ImageMedia) => ({
            ...m,
            loading: false,
            id: m.id,
            type: m.__typename,
            url: m.url || '',
          }))}
        />
      )}
    </div>
  );
};

Body.displayName = 'TimelineEntryBody';
